import { render } from "@testing-library/react";
import "@testing-library/jest-dom";
import { CssVarsProvider } from "@mui/joy/styles";
import { CanvasTypeSelect } from "./CanvasTypeSelect";

it("keeps the builder canvas type Select controlled when its value is missing", () => {
  const consoleError = jest
    .spyOn(console, "error")
    .mockImplementation(() => {});
  const onChange = jest.fn();
  const { rerender } = render(
    <CssVarsProvider>
      <CanvasTypeSelect value="entry" onChange={onChange} />
    </CssVarsProvider>,
  );

  rerender(
    <CssVarsProvider>
      <CanvasTypeSelect value={undefined} onChange={onChange} />
    </CssVarsProvider>,
  );

  expect(consoleError).not.toHaveBeenCalledWith(
    expect.stringContaining(
      "changing a controlled prop to be uncontrolled: selectedValues",
    ),
  );
  consoleError.mockRestore();
});
